import styled from "styled-components"

import {
  Heading,
  HeadingXL,
  Body,
  HeadingSmall,
  TextLink,
} from "../../../../component-library/design/typography/typography.styles"
import { SPACING } from "../../../../component-library/design/spacing/spacing.constants"
import { COLOR } from "../../../../component-library/design/color/color.constants"
import { Button } from "../../../../component-library/components/button/button.component"
import getCountry from 'ggx-src/legacy/views/helpers/get_country'

const StyledHeading = styled(Heading)`
  display: flex;
  align-items: center;
  margin-bottom: ${SPACING.S};
  cursor: pointer;
`

const StyledSubheading = styled(HeadingSmall)`
  margin: ${SPACING.M} 0 ${SPACING.XXS} 0;
`

const StyledTotal = styled((props) => <HeadingXL {...props} as="p" />)`
  color: ${(props) => (props.total === 0 ? COLOR.GREY_DARK : COLOR.BLACK)};
`

const StyledError = styled(Body)`
  margin: ${SPACING.XS} 0 0;
  color: ${COLOR.RED_MEDIUM};
`

const StyledPaymentWrapper = styled.div`
  border-top: 1px solid ${COLOR.GREY_LIGHT};
  margin-top: ${() => getCountry() === 'HK' || getCountry() === 'SG' ? '20px': SPACING.M};
  padding-top: ${() => getCountry() === 'HK' || getCountry() === 'SG' ? '20px': SPACING.M};
`

const StyledDisplayCardWrapper = styled.div`
  display: inline-block;
  width: 100%;
  margin-right: ${SPACING.XS};
`

const StyledTextLink = styled(TextLink)`
  display: inline-block;
  margin-top: ${SPACING.XS};
  cursor: pointer;
`

const StyledAddCardButton = styled(Button)`
  display: inline-block;
  margin-top: ${SPACING.XS};
  padding: 12px ${SPACING.S};
  vertical-align: top;
`

const LoadingContainer = styled.div`
  height: 176px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export {
  StyledHeading,
  StyledSubheading,
  StyledTotal,
  StyledError,
  StyledPaymentWrapper,
  StyledDisplayCardWrapper,
  StyledTextLink,
  StyledAddCardButton,
  LoadingContainer,
}
